import React, { SFC } from 'react';
import { IProductData } from 'interfaces/IProductData';
import YoutubeEmbed from '../../YoutubeEmbed';
import Translate from 'components/Translate';
import Hidden from '@material-ui/core/Hidden';
import { getCdnImage } from 'functions';
import { enProductType } from 'enums/enProductType';
import { TicketTimer } from '../TicketTimer/index';
import { Locale } from '../Locale';

const styles = require('./sidebar.css');

interface IProps {
  cart: IProductData;
}

// tslint:disable-next-line:variable-name
export const Sidebar: SFC<IProps> = (props) => {

  const bannerId = props.cart.config.template.media.bannerRight;

  const bannerUrl = getCdnImage(bannerId);

  const product = props.cart.products[0];

  return (
    <div className={styles.component}>
      {props.cart.config.productType == enProductType.TICKET ?
        <div>
          <Hidden xsDown>
            <div className={'chk-banner-right timer'}>
              <TicketTimer />
            </div>
          </Hidden>
        </div>
        : null
      }

      <div className={'chk-banner-right'}>
        <Hidden xsDown>
          <YoutubeEmbed url={props.cart.config.template.media.bannerYoutube} />
          {bannerId
            ? <img alt={props.cart.title} src={bannerUrl.includes('data:') ? bannerId : bannerUrl} />
            : <div className='chk-sideBar__description'>
              <div className='title'>
                <Translate term='Detalhes' />
              </div>
              <div className='content-description' dangerouslySetInnerHTML={{ __html: product.description }} />
              <div className='infos'>
                <span className='producerName'><Translate term='Oferecido por' /> <b>{product.producerName}</b></span>
                <br />
                <span>{product.producerEmail}</span>
              </div>
            </div>
          }
        </Hidden>
      </div>
      {props.cart.config.productType == enProductType.TICKET ?
        <Hidden xsDown>
          <div className={'chk-banner-right locale'}>
            <Locale />
          </div>
        </Hidden>
        : null
      }
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/components/Cart/Sidebar/index.tsx